/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { getAgent } from "./agent";
import loadingConfig from "./config/loading.config.json";
import errorConfig from "./config/error.config.json";
import pageConfig from "./config/myTickets.config.json";

export class TicketsPageService {
  private static instance: TicketsPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): TicketsPageService {
    if (!TicketsPageService.instance) {
      TicketsPageService.instance = new TicketsPageService(props);
    }
    return TicketsPageService.instance;
  }

  public getStaticPageContent() {
    return { loading: loadingConfig, error: errorConfig, page: pageConfig };
  }

  public async getMyTickets() {
    const agent = getAgent();
    return agent.getMyTickets();
  }
}
